export class SuitabilityType {
    ApplicationDetailId: number;
    SuitabilityTypeId: number;
}